// src/palettes/pastelPalettes.js
const pastelPalettes = [
  { name: 'Cotton Candy', colors: ['#FFB3BA', '#BAFFC9', '#BAE1FF', '#FFFFBA', '#FFB3F7'] },
  { name: 'Soft Morning', colors: ['#E6E6FA', '#F0E6FA', '#FAE6FA', '#FAE6F0', '#D1D1E6'] },
  { name: 'Sweet Mint', colors: ['#98FF98', '#B4FFB4', '#D0FFD0', '#EBFFEB', '#7ACC7A'] },
  { name: 'Lavender Dream', colors: ['#E6E6FA', '#F0E6FA', '#FAE6FA', '#FAE6F0', '#D1D1E6'] },
  { name: 'Peach Fuzz', colors: ['#FFDAB9', '#FFE4C4', '#FFECB3', '#FFF2CC', '#FFE5B4'] },
  { name: 'Powder Blue', colors: ['#B0E0E6', '#C4EDFF', '#D8F9FF', '#ECFFFF', '#E0FFFF'] },
  { name: 'Mint Cream', colors: ['#F5FFFA', '#E0FFF4', '#CCFFE9', '#B8FFDF', '#A4FFD4'] },
  { name: 'Blush Pink', colors: ['#FFC0CB', '#FFB6C1', '#FFAEB9', '#FF9AA2', '#FF869B'] },
  { name: 'Pastel Rainbow', colors: ['#FFB3BA', '#BAFFC9', '#BAE1FF', '#FFFFBA', '#FFB3F7'] },
  { name: 'Dreamy Pastel', colors: ['#FADADD', '#E8D0F0', '#D0E8F8', '#C4F0F0', '#B3E6FF'] },
  { name: 'Whisper Pink', colors: ['#FFE4E1', '#FFD1DC', '#FFC0CB', '#FFB6C1', '#FFAEB9'] },
  { name: 'Fairy Dust', colors: ['#FCE4EC', '#F8BBD0', '#F48FB1', '#F06292', '#EC407A'] },
  { name: 'Light Lilac', colors: ['#E6E6FA', '#D8BFD8', '#DDA0DD', '#EE82EE', '#DA70D6'] },
  { name: 'Serene Blue', colors: ['#B0C4DE', '#A2B5CD', '#8DA7B8', '#708090', '#5F6A78'] },
  { name: 'Calm Green', colors: ['#98FB98', '#90EE90', '#80C080', '#66B266', '#4DA64D'] },
  { name: 'Sunset Pastel', colors: ['#FFD1DC', '#FFE4E1', '#FFF0F5', '#FFF5EE', '#FFF8DC'] },
  { name: 'Soft Coral', colors: ['#FADCD9', '#F9C2B2', '#F7A89B', '#F59184', '#F36C6C'] },
  { name: 'Sugar Plum', colors: ['#EADCF2', '#E3C9E9', '#DBB5E0', '#D2A1D7', '#CA8ECD'] },
  { name: 'Baby Blue', colors: ['#D0E9F8', '#C2E0F4', '#B4D7F0', '#A6CDFC', '#98C4F8'] },
  { name: 'Peony', colors: ['#FADADD', '#F7C2C2', '#F4A8A8', '#F19191', '#EE7777'] },
  { name: 'Cherry Blossom', colors: ['#FFE6F2', '#FFD1E6', '#FFBDD9', '#FFA8CD', '#FF94C0'] },
  { name: 'Marshmallow', colors: ['#FDFDFE', '#F8F8FB', '#F3F3F7', '#EDEDEF', '#E8E8EB'] },
  { name: 'Powder Pink', colors: ['#FFDDE1', '#FFC4C8', '#FFABB0', '#FF9198', '#FF7880'] },
  { name: 'Minty Mist', colors: ['#E0FFF0', '#CCFFE8', '#B8FFE0', '#A3FFD8', '#8FFFCC'] },
  { name: 'Lemon Chiffon', colors: ['#FFF9DB', '#FFF4C6', '#FFEFB1', '#FFEA9C', '#FFE586'] },
  { name: 'Pale Peach', colors: ['#FFEBD6', '#FFE5C4', '#FFDFB2', '#FFD9A0', '#FFD28E'] },
  { name: 'Sky Pastel', colors: ['#D0F0FD', '#B8E8FB', '#A0E0F9', '#88D8F7', '#70D0F5'] },
  { name: 'Blush Apricot', colors: ['#FFE3D8', '#FFD0BF', '#FFBDA6', '#FFA98D', '#FF9574'] },
  { name: 'Pastel Sorbet', colors: ['#FFF1E0', '#FFE1C2', '#FFD2A4', '#FFC285', '#FFB267'] },
  { name: 'Cloud Nine', colors: ['#F0F8FF', '#E0F2FF', '#D0ECFF', '#C0E6FF', '#B0E0FF'] },
  { name: 'Feather Touch', colors: ['#F7F4FF', '#EDE9FF', '#E4DEFF', '#DAD3FF', '#D0C8FF'] },
  { name: 'Mellow Yellow', colors: ['#FFF8D7', '#FFF3BF', '#FFEEA8', '#FFE992', '#FFE47B'] }
];

export default pastelPalettes;
